<template>
  <div>
    <div class="breadcrumb">
      <h1 style="color: #AC8400;">SPD Records History</h1>
    </div>

    <!-- Breadcrumbs -->
    <div style="padding: 10px; background-color: #F2F2F2">
      <router-link to="/dashboard">
        Dashboard
      </router-link>
      /

      <b>TBA</b> /

      <b>SPD Entry Log</b>
    </div>
    <!-- End of breadcrumbs -->

    <div class="separator-breadcrumb border-top"></div>
    <div class="row mb-4">
      <div class="col-md-12 mb-4">
        <div class="card text-left">
          <div class="card-body">
            <h4 class="card-title mb-3">
              SPD records History
            </h4>

            <!-- <p>The table below shows call requests for TBA.</p> -->

            <div class="row">
              <div class="col-6">
                <label><b>Date From</b></label>
                <input type="date" class="form-control" v-model="dto.start_date" />
              </div>
              <div class="col-6">
                <label><b>Date To</b></label>
                <input type="date" class="form-control" v-model="dto.end_date" />
              </div>
            </div>

            <br>

            <div class="text-right">
              <button
                class="btn btn-rounded btn-primary mr-2"
                style="width: 150px;"
                @click="filter()"
              >
                Filter
              </button>
              <button
                class="btn btn-rounded btn-primary"
                style="width: 150px;"
                @click="reset()"
              >
                Reset
              </button>
            </div>

            <br>

            <div class="table-responsive">
              <table
                id="tba_spd_record_history_tbl"
                class="display table table-striped table-bordered"
                style="width:100%; text-align: center;"
              >
                <thead>
                  <tr>
                    <th>No.</th>
                    <th>Sys ID</th>
                    <th>I.C No</th>
                    <th>Certificate No</th>
                    <th>Vehicle No</th>
                    <th>Sum Insured</th>
                    <th>Amount Paid</th>
                    <th>NCD</th>
                    <th>Source</th>
                    <th>Start Date</th>
                    <th>End Date</th>
                    <th>Purchased At</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(spd, index) in spd_passed_lists" :key="index">
                    <td>{{ index + 1 }}</td>
                    <td>{{ spd.sys_id }}</td>
                    <td>{{ spd.ic_number }}</td>
                    <td>{{ spd.certificate_number }}</td>
                    <td>{{ spd.vehicle_number }}</td>
                    <td>B$ {{ (Number(spd.sum_covered)).toLocaleString('en-US') }}</td>
                    <td>B$ {{ (Number(spd.amount_paid)).toLocaleString('en-US') }}</td>
                    <td>{{ spd.ncd }}%</td>
                    <td>{{ spd.source }}</td>
                    <td>{{ spd.start_date }}</td>
                    <td>{{ spd.end_date }}</td>
                    <td>{{ spd.purchased_at| moment("DD/MM/YYYY H:mm:ss") }}</td>
                    <td>
                      <router-link class="btn btn-primary btn-block" :to="redirect(spd.sys_id, 1)" >View Details</router-link>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <loading
          :active.sync="isLoading"
          :can-cancel="false"
          :is-full-page="fullPage"
        ></loading>
        <br />
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { createSpdRecord, getPassedSpdRecords } from "@/services/SpdRecordService";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  name: "tba_speed_records_history",
  components: {
    Loading
  },
  data() {
    return {
      spd_passed_lists: [],
      dto: {
        start_date: null,
        end_date: null,
      },
      isLoading: false,
      fullPage: true,
    };
  },

  methods: {
    async loadSpdEntry() {
      try {
        const response = await getPassedSpdRecords(this.dto);

        this.spd_passed_lists = response.data.data.spd_records;
      } catch (error) {
        swal("Try Again", error.response.data.message, "error");
      }
    },

    async repush(spd) {
      try {
        const response = await createSpdRecord(spd);

        swal("Successfully pushed to SPD", response.data.message, "success")
          .then(async (value) => {
            this.destroyDataTables();
            await this.loadSpdEntry();
            this.setDatatable();
          });
      } catch (error) {
        swal("Try Again", error.response.data.message, "error");
      }
      
    },

    setDatatable() {
      this.loadTable("#tba_spd_record_history_tbl");
    },

    destroyDataTables() {
      this.destroyDataTable("#tba_spd_record_history_tbl");
    },

    destroyDataTable(id) {
      $(id).DataTable().destroy();
    },

    loadTable(id) {
      $(id).DataTable({
        pageLength: 5,
        dom: "Bfrtip",
        buttons: [
          {
            extend: "excelHtml5",
            exportOptions: {
              // columns: [0, 1, 2, 3, 4]
              columns: ':not(:last-child)',
            }
          },
          {
            extend: "pdfHtml5",
            orientation: 'landscape',
            pageSize: 'LEGAL',
            exportOptions: {
              // columns: [0, 1, 2, 3, 4]
              columns: ':not(:last-child)',
            }
          }
        ]
      });
    },

    redirect(id, type) {
      return `/tba/spd_records/${id}/${type}`;
    },

    async filter() {
      this.isLoading = true;

      if(this.dto.start_date === null || this.dto.end_date === null) {
        swal("Try Again", "Please fill in start and end date", "error");
        return;
      }

      this.destroyDataTables();
      this.spd_passed_lists = [];
      await this.loadSpdEntry();
      this.setDatatable();
      this.isLoading = false;
    },

    async reset() {
      this.isLoading = true;

      this.dto.start_date = this.dto.end_date = null;

      this.destroyDataTables();
      this.spd_passed_lists = [];
      await this.loadSpdEntry();
      this.setDatatable();
      this.isLoading = false;
    }
  },
  async created() {
    this.isLoading = true;
    await this.loadSpdEntry();
    this.setDatatable();
    this.isLoading = false;
  }
};
</script>

<style>
.spanDateTime {
  display: none;
}
</style>
